export const LOGS_ROUTE = 'logs';
export const LOGS_CONFIG_NAME = 'logs';
